 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		42: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"06f3e3b7b8e0ecdee43bd0a33dce01534a0421d5","1":"897b9928c10ee8ae26ed63a72af54513c551bd9b","2":"1bfc9850","3":"de1a70420612e6f1e3ada45dc19422c5157c59b4","4":"ea591e3c34e3c501e0847b99fe45de8a7bf150b0","5":"0354e0893466134327875db2843ddf721ad10bad","6":"644c1b1464488e120d8a23d9b0ddc6bd2abf510b","7":"e64d8a7999880d27b06ef03343e5525570e756fa","8":"99319532dbf2d50be9ab62532466f2b40e7a4a1b","13":"a22cbe4e","14":"ae51ba48","16":"component---cache-caches-gatsby-plugin-offline-app-shell-js","17":"component---src-pages-404-js","18":"component---src-pages-about-js","19":"component---src-pages-blog-search-js","20":"component---src-pages-contact-commercial-js","21":"component---src-pages-contact-js","22":"component---src-pages-education-courses-js","23":"component---src-pages-education-educators-js","24":"component---src-pages-education-js","25":"component---src-pages-enterprise-js","26":"component---src-pages-index-js","27":"component---src-pages-media-kit-js","28":"component---src-pages-press-js","29":"component---src-pages-research-js","30":"component---src-pages-research-researchers-js","31":"component---src-pages-team-js","32":"component---src-pages-technology-js","33":"component---src-templates-blog-author-js","34":"component---src-templates-blog-authors-js","35":"component---src-templates-blog-post-js","36":"component---src-templates-blog-posts-js","37":"component---src-templates-research-library-js","38":"component---src-templates-research-paper-js","39":"component---src-templates-team-member-js","40":"component---src-templates-video-js"}[chunkId]||chunkId) + "-" + {"0":"5e56a05b1000d27718af","1":"0bfb1873c8586745daff","2":"cd29adc0c06206151f91","3":"3a788466ea938b63915f","4":"3ddacd692ef62bcd4399","5":"1a98a0867fe8b4caab15","6":"7048e6d346b6c896974e","7":"196d1f0e409deb4c41d4","8":"a3546b811f8951d98dd0","13":"efbdcb5104b27315ff0e","14":"2c1d6a471b244b2476ca","16":"15f4c67f8476504b30ea","17":"c682f08ed2072e8981a0","18":"4b534b59320ab084a34b","19":"6c2ee797cbb7b38d9dea","20":"9c33f3d6390e7109e736","21":"8f5c3aef81ead1d7b2b9","22":"cc0a69e375c9feead456","23":"9a8a2c8d1db42b541478","24":"dbd8e6fe75c3158a869e","25":"517044482c83fccff31a","26":"c9e242d4e1a3bc66bf2a","27":"1b1bf52ae8234db1daf7","28":"477d0eb99c34bd2fabf6","29":"8a2920f30eb2a945d9c0","30":"46b67198aaf32e2eae1e","31":"3354f8c4dafd735a1c10","32":"9185e337ac4b9e8065d1","33":"339846865e62b633b452","34":"6a4627e7600d0df08985","35":"85879ecbd703904de3ab","36":"1dbb8783a8f695452206","37":"e9d6e854cf886375dbdb","38":"3cfa75bc8b515337cc7d","39":"5c025707ec9a0ffda15b","40":"e90d1b196daf0e049a8a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
